export default __webpack_public_path__ + "static/media/MainLogo.321d92f2.svg";